import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = {
  key: 0,
  class: "inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-white/15 px-1 text-[10px] font-bold leading-none text-white"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SortButton',
  props: {
    label: {},
    active: { type: Boolean },
    direction: {},
    priority: {}
  },
  emits: ["click"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "inline-flex items-center gap-2 text-left text-sm font-semibold text-blue-100 transition hover:text-white focus:outline-none focus:ring-0 active:outline-none",
    "aria-label": `Urutkan berdasarkan ${__props.label}`,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click', $event)))
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.label), 1),
    (__props.active && __props.priority && __props.priority > 1)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.priority), 1))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock("svg", {
      class: _normalizeClass(["h-4 w-4 shrink-0 transition-transform", [
        __props.active ? 'text-white' : 'text-blue-200/70',
        __props.active && __props.direction === 'asc' ? 'rotate-180' : '',
      ]]),
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor",
      "stroke-width": "3.25",
      "aria-hidden": "true"
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "m6 9 6 6 6-6"
      }, null, -1)
    ]))], 2))
  ], 8, _hoisted_1))
}
}

})